import { render, staticRenderFns } from "./stockManagement.vue?vue&type=template&id=3abbc8d2&scoped=true"
import script from "./stockManagement.vue?vue&type=script&lang=js"
export * from "./stockManagement.vue?vue&type=script&lang=js"
import style0 from "./stockManagement.vue?vue&type=style&index=0&id=3abbc8d2&prod&scoped=true&lang=css"
import style1 from "./stockManagement.vue?vue&type=style&index=1&id=3abbc8d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abbc8d2",
  null
  
)

export default component.exports